import { useBuildLogAnimation } from '../hooks/use-build-log-animation';
import IdeShell from '../components/ide-shell';
import CodeEditorVideo from '../components/code-editor-video';
import OutputPanel from '../components/output-panel';

export default function ErrorScene({
  code = '',
  errors = [],
  filename = 'Program.cs',
  projectName = 'HelloWorld',
  breakpoints,
  debugLine,
}) {
  const errorLogs = errors.map(e => ({
    text: `error ${e.message}`,
    type: 'error',
  }));
  const visibleLogs = useBuildLogAnimation(errorLogs);
  const lineCount = code ? code.split('\n').length : 1;

  return (
    <IdeShell projectName={projectName} filename={filename} step={3} lineCount={lineCount}>
      <CodeEditorVideo
        typedCode={code}
        step={3}
        lineCount={lineCount}
        projectName={projectName}
        filename={filename}
        errors={errors}
        breakpoints={breakpoints}
        debugLine={debugLine}
      />
      <OutputPanel buildLogs={visibleLogs} />
    </IdeShell>
  );
}
